<script>
export let toggleLegalNotice;
export let togglePrivacyPolicy;
</script>
  <footer>
    <a href='#legal-notice' on:click={toggleLegalNotice}>Aviso Legal</a>
    <a href='#privacyModal' on:click={togglePrivacyPolicy}>Politica de privacidad</a>
  </footer>

<style>

  footer {
    position: absolute;
    bottom: 0;
    right: 680px;


    text-align: right;
    margin-top: auto;
    margin-bottom: 10px;
    display: flex;
    color:gray;
  }
  footer a {
    font-size: 15px;
    margin-right: 20px;
    color:gray;
  }

@media (max-width:1350px)  { 
  footer {
    position: relative;
    margin-left: 10px;
    right: 0;
    margin-bottom: 0;
  }

}
</style>